import React from 'react';
import swal from 'sweetalert';
import { GridCell } from '@progress/kendo-react-grid';

export default function CellWithEditing(edit, toggleActive) {
	return class extends GridCell {
		render() {
			return (
				<td>
					<button
						className="admin-k-button "
						onClick={() => {
							edit(this.props.dataItem);
						}}
					>
						<i className="fas fa-pen"></i>
					</button>
					&nbsp;
					{this.props.dataItem.isActive ? (
						<button
							className="admin-k-button "
							onClick={() => {
								swal({
									title: 'Are you sure?',
									text: `Once deactivated, ${this.props.dataItem.firstName} ${this.props.dataItem
										.lastName} will no longer be able to login.`,
									icon: 'warning',
									buttons: {
										cancel: 'CANCEL',
										confirm: 'OK'
									},
									dangerMode: true
								}).then((value) => (value ? toggleActive(this.props.dataItem) : null));
							}}
						>
							<i className="fas fa-times-circle"></i>
						</button>
					) : (
						<button
							className="admin-k-button "
							style={{width:"140px"}}
							onClick={() => {
								swal({
									text: `Are you sure you want to re-activate ${this.props.dataItem.firstName} ${this.props.dataItem.lastName} ?`,
									buttons: {
										cancel: 'NO',
										confirm: 'YES'
									},
								}).then((value) => (value ? toggleActive(this.props.dataItem) : null));								
							}}
						>
							<i className="fas fa-check-circle"></i>
						</button>
					)}
				</td>
			);
		}
	};
}
